import { toast } from "@shared/services/toast";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useRemoveQueryParam } from "./useRemoveQueryParam";

const getProvider = (plan: string) => {
  const providers = {
    miamire: "MIAMI Realtors",
    claw: "TheMLS/CLAW",
  };
  return providers[plan as keyof typeof providers] || null;
};

export const useHandleSSOErrors = () => {
  const [searchParams] = useSearchParams();
  const removeQueryParams = useRemoveQueryParam(["error", "plan"]);

  const error = useMemo(() => {
    const error = searchParams.get("error");
    const plan = searchParams.get("plan");

    if (!error) return null;
    if (error === "invalid-account") {
      return "Account not found or disabled. If you think this is a mistake, please reach out to our support team for further assistance.";
    }
    if (error.startsWith("unexpected")) {
      if (plan) {
        return `An unexpected error occurred while attempting to log in with ${
          getProvider(plan) || "the selected SSO provider"
        }. Please try again or contact support for assistance.`;
      }
      return "An unexpected error occurred. Please try again later or contact support if the issue persists.";
    }
    return "Something went wrong. Please try again later or contact support if the issue persists.";
  }, [searchParams]);

  useEffect(() => {
    if (error) {
      toast.error(error, { autoClose: 15000, toastId: "sso-auth-error" });
      removeQueryParams();
    }
  }, [error, removeQueryParams]);

  return error;
};
